import { Injectable } from '@angular/core';


@Injectable()
export abstract class LoggingService {
    /**
     * Log angular events
     */
    abstract Log(action: string, properties: any);
    abstract GoogleAnalytics(  eventName: string, 
        eventCategory: string,  
        eventLabel: string,  
        eventValue: number);
}